import { FunctionComponent } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import classnames from 'classnames'

import Icon from 'components/ui/icon'
import { NavItem } from './navItems'
import sidebarCss from './sidebar.module.scss'

/**
 * "/" renders the role's home page (the first nav item),
 * so it is treated as that item for the active state.
 */
const useIsActive = (items: NavItem[]) => {
  const { pathname } = useLocation()

  return (item: NavItem) =>
    pathname === '/'
      ? item === items[0]
      : pathname === item.to || pathname.startsWith(`${item.to}/`)
}

const SidebarNav: FunctionComponent<{
  items: NavItem[]
  onNavigate: () => void
}> = ({ items, onNavigate }) => {
  const isActive = useIsActive(items)

  return (
    <nav className={sidebarCss.nav} aria-label="Navegação principal">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          onClick={onNavigate}
          className={classnames(
            sidebarCss.navLink,
            isActive(item) && sidebarCss.navLinkActive
          )}
          aria-current={isActive(item) ? 'page' : undefined}
        >
          <Icon name={item.icon} />
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}

export default SidebarNav
